/*
* @Author: gujianghua
* @Date:   2020-10-21 16:43:04
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-11-05 11:11:59
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	// 获取列表
	getDataList(params) {
	    return service({
			url: '/cloud/course/v1/admin/wechatGroup/findByList',
			method: 'post',
			params: params
		})
	},
	add(data) {
		return service({
			url: '/cloud/course/v1/admin/wechatGroup/insert',
			method: 'post',
			data: data
		})
	},
	edit(data) {
		return service({
			url: '/cloud/course/v1/admin/wechatGroup/updateNum',
			method: 'post',
			data: data
		})
	},
	delete(path) {
		return service({
			url: '/cloud/course/v1/admin/wechatGroup/delete/' + path,
			method: 'get'
		})
	},
	/* 群成员管理 */
	memberList(data) {
		return service({
			url: '/cloud/course/v1/admin/wechatGroup/findByUserList',
			method: 'post',
			data
		})
	},
	memberAdd(data) {
		return service({
			url: '/cloud/course/v1/admin/wechatGroup/insertUser',
			method: 'post',
			data
		})
	},
	memberDel(params) {
		return service({
			url: '/cloud/course/v1/admin/wechatGroup/deleteUser',
			method: 'get',
			params
		})
	},
	questionList(data) {
		return service({
			url: '/cloud/course/v1/admin/tableQuestion/findByPage',
			method: 'post',
			data
		})
	},
	questionAdd(data) {
		return service({
			url: '/cloud/course/v1/admin/tableQuestion/insert',
			method: 'post',
			data
		})
	},
	questionEdit(data) {
		return service({
			url: '/cloud/course/v1/admin/tableQuestion/update',
			method: 'post',
			data
		})
	},
	questionDel(path) {
		return service({
			url: '/cloud/course/v1/admin/tableQuestion/delete/' + path,
			method: 'get'
		})
	},
	questionDetail(path) {
		return service({
			url: '/cloud/course/v1/admin/tableQuestion/findById/' + path,
			method: 'get'
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/operateManage/cloudgroup.js